/// <amd-module name="redux/Utils/ActionHelper" />
import { Action as ReduxAction } from "redux";
import { MetaTypes } from "redux/Actions/MetaTypes";
// tslint:disable-next-line:interface-name
export interface Action<T> extends ReduxAction<T> {
    /**
     * The meta property for the action (see Flux Standard Actions)
     */
    meta?: { [key: string]: any };
}

/**
 * A better typing for the Redux Action
 */
// tslint:disable-next-line:interface-name
export interface ActionWithPayload<T extends string, P> extends Action<T> {
    /**
     * The payload of this action
     */
    payload: P;
}

/**
 * Create a new action with type and payload
 * @param type The action type
 * @param payload The payload
 */
export function createAction<T extends string>(type: T): Action<T>;
export function createAction<T extends string, P>(type: T, payload: P, meta?: { [key: string]: string }): ActionWithPayload<T, P>;
// tslint:disable-next-line:typedef
export function createAction<T extends string, P>(type: T, payload?: P, meta?: { [key: string]: string }) {
    return { type, payload, meta };
}

/**
 * Creates an action which indicate that this is an action required for TTI
 */
export function ttiAction<T, A extends Action<T>>(action: A): A {
    if (!action.meta) {
        action.meta = {};
    }

    action.meta[MetaTypes.TTI_ACTION] = MetaTypes.TTI_ACTION;
    return action;
}

export function trackedAction<T, A extends Action<T>>(action: A, telemetryProps?: { [key: string]: any }): A {
    if (!action.meta) {
        action.meta = {};
    }

    action.meta[MetaTypes.TELEMETRY_PROPS] = telemetryProps || {};
    return action;
}

export function trackedErrorAction<T extends string, A extends ActionWithPayload<T, any>>(action: A): A {
    if (!action.meta) {
        action.meta = {};
    }

    action.meta[MetaTypes.ERROR_TELEMETRY_PROPS] = action.payload || {};
    return action;
}

/**
 * @copyright Copyright (c) 2018 Martin Hochel
 * Borrowed from the rex-tils library
 */

type ActionsCreatorsMapObject = { [actionCreator: string]: (...args: any[]) => any };
export type ActionsUnion<A extends ActionsCreatorsMapObject> = ReturnType<A[keyof A]>;
export type ActionsOfType<ActionUnion, ActionType extends string> = ActionUnion extends Action<ActionType> ? ActionUnion : never;
